import React, { Component } from "react";

import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';

const mapStyles = {
  width: '100%',
  height: '100%',
};

class MapContainer extends Component {
  render() {
    return (
        <Map
          google={this.props.google}
          zoom={15}
          style={mapStyles}
          initialCenter={{ lat: 10.788430, lng: 106.701670}}
        >
          <Marker position={{ lat: 10.788430, lng: 106.701670}} />
        </Map>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyCFPd32IqdW9IY2PTsdJnkohoc-zpyhu5A'
})(MapContainer);